// components/pinned-projects/PinnedProjectTree.jsx
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";

import { db } from "../../firebase/firebase.utils";
import "../collab-projects/collab-projects.scss";

export const pinnedProjectUrl = (project) =>
  `/s/${project.fromSpaceId}/e/${project.stationId}/b`;

export default function PinnedProjectTree({
  onNavigate,
  heading = true,
}) {
  const currentUser = useSelector((state) => state.user.currentUser);

  const [projects, setProjects] = useState(
    currentUser?.favoriteStations || [],
  );
  const [open, setOpen] = useState(true);

  const { pathname } = useLocation();

  useEffect(() => {
    if (!currentUser?.uid) {
      setProjects([]);
      return;
    }

    setProjects(currentUser.favoriteStations || []);

    return db
      .collection("users")
      .doc(currentUser.uid)
      .onSnapshot((doc) => {
        setProjects(doc.data()?.favoriteStations || []);
      });
  }, [currentUser?.uid]);

  return (
    <section
      className="collab-tree pinned-tree"
      aria-label="Pinned Projects"
    >
      {heading && (
        <div className="collab-tree__header-row">
          <button
            type="button"
            className="collab-tree__heading"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            <span className="collab-dot" aria-hidden="true" />
            <strong>Pinned Projects</strong>
          </button>

          <button
            type="button"
            className="collab-tree__toggle"
            aria-label={
              open ? "Collapse Pinned Projects" : "Expand Pinned Projects"
            }
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            <FiChevronRight className={open ? "is-open" : ""} />
          </button>
        </div>
      )}

      {(!heading || open) &&
        (!projects.length ? (
          <p className="collab-tree__status">No pinned projects yet.</p>
        ) : (
          <ul className="collab-tree__projects pinned-tree__projects">
            {projects.map((project) => {
              const url = pinnedProjectUrl(project);
              const selected = pathname.startsWith(url.slice(0, -1));

              return (
                <li
                  key={`${project.fromSpaceId}-${project.stationId}`}
                  className="collab-tree__branch"
                >
                  <Link
                    to={url}
                    className={`collab-tree__project${
                      selected ? " is-selected" : ""
                    }`}
                    aria-current={selected ? "page" : undefined}
                    onClick={onNavigate}
                  >
                    <span className="collab-tree__emoji">
                      {project.emojicon || "📋"}
                    </span>

                    <span title={project.name}>
                      {project.name || "Untitled project"}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        ))}
    </section>
  );
}
